var _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMusiccc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    transform: "scale(-.7, .7)",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-145",
    d: "M75.66,446.55c-96.29-55.59-96.29-145.72,0-201.31s252.4-55.59,348.68,0,96.29,145.72,0,201.31S172,502.14,75.66,446.55Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-145",
    d: "M101.22,370.34,294.64,258.69a9.43,9.43,0,0,1,8.56,0L383,304.75c2.36,1.36,2.36,3.58,0,4.94L189.57,421.34a9.43,9.43,0,0,1-8.56,0l-79.79-46.06C98.86,373.91,98.86,371.7,101.22,370.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-145",
    d: "M381.12,305.38l-45.31-26.16c-2.7-1.56-2.7-4.09,0-5.65l63.77-36.82a10.82,10.82,0,0,1,9.79,0L454.58,263c2.7,1.57,2.69,4.1,0,5.66L390.9,305.38A10.8,10.8,0,0,1,381.12,305.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-145",
    d: "M113.93,459.35,68.63,433.2c-2.71-1.56-2.71-4.09,0-5.65l57.74-33.44a10.8,10.8,0,0,1,9.78,0l45.21,26.2c2.7,1.57,2.7,4.1,0,5.66l-57.64,33.37A10.76,10.76,0,0,1,113.93,459.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-145",
    d: "M84.43,305,39,278.59c-2.93-1.7-2.93-4.45,0-6.14l69.27-40a11.75,11.75,0,0,1,10.63,0l45.29,26.48c2.94,1.7,2.93,4.45,0,6.15L95.06,305A11.72,11.72,0,0,1,84.43,305Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speakers-2--inject-145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speakers--inject-145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speaker--inject-145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.62,127.94,47.21,157.62a11.13,11.13,0,0,0-5,8.73V269.41a11.16,11.16,0,0,0,5,8.73l37.22,21.49a11.18,11.18,0,0,0,10.08,0L145.92,270a11.16,11.16,0,0,0,5-8.74v-103a11.16,11.16,0,0,0-5-8.74L108.7,127.94A11.12,11.12,0,0,0,98.62,127.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.26,299.7c-1.36,0-2.18-1.12-2.18-3v-103a10.5,10.5,0,0,1,4.74-8.2l51.41-29.68a4,4,0,0,1,1.94-.61c1.36,0,2.18,1.12,2.18,3v103a10.47,10.47,0,0,1-4.74,8.2l-51.4,29.68A4,4,0,0,1,92.26,299.7Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.17,155.79h0c1.41,0,1.56,1.65,1.56,2.37v103a9.92,9.92,0,0,1-4.43,7.67L93.9,298.56a3.37,3.37,0,0,1-1.64.53c-1.41,0-1.56-1.66-1.56-2.38v-103A9.94,9.94,0,0,1,95.13,186l51.4-29.68a3.45,3.45,0,0,1,1.64-.52m0-1.23a4.54,4.54,0,0,0-2.25.69L94.51,184.93a11.13,11.13,0,0,0-5,8.73v103c0,2.29,1.14,3.6,2.79,3.6a4.62,4.62,0,0,0,2.25-.68L145.92,270a11.16,11.16,0,0,0,5-8.74v-103c0-2.28-1.14-3.6-2.79-3.6Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.43,184.93,47.21,163.44c-2.78-1.61-5-.31-5,2.91V269.41a11.16,11.16,0,0,0,5,8.73l37.22,21.49c2.78,1.6,5,.3,5-2.92v-103A11.13,11.13,0,0,0,84.43,184.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.7,127.94l37.22,21.48c2.78,1.61,2.78,4.22,0,5.83L94.51,184.93a11.18,11.18,0,0,1-10.08,0L47.21,163.44c-2.78-1.61-2.78-4.22,0-5.82l51.41-29.68A11.12,11.12,0,0,1,108.7,127.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.22,273.74c11.69-6.76,21.17-23.18,21.17-36.68s-9.48-19-21.18-12.23S99,248,99,261.51,108.52,280.49,120.22,273.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.22,271.28c10.52-6.07,19.05-20.85,19.05-33s-8.53-17.07-19.06-11-19,20.85-19,33S109.69,277.36,120.22,271.28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.22,262.13c6.14-3.55,11.12-12.17,11.12-19.27s-5-10-11.13-6.42-11.12,12.17-11.12,19.27S114.07,265.67,120.22,262.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.22,253.1a7.31,7.31,0,0,0,3.3-5.72c0-2.11-1.48-3-3.3-1.91a7.28,7.28,0,0,0-3.31,5.72C116.91,253.3,118.39,254.15,120.22,253.1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.22,217c8.62-5,15.61-17.09,15.61-27.05s-7-14-15.62-9S104.6,198,104.6,208,111.59,222,120.22,217Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.22,215.19c7.76-4.48,14.05-15.38,14.05-24.34s-6.29-12.59-14.06-8.11-14,15.38-14,24.34S112.46,219.67,120.22,215.19Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.22,208.44c4.53-2.62,8.2-9,8.2-14.21s-3.67-7.35-8.2-4.74-8.21,9-8.21,14.21S115.68,211.05,120.22,208.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.22,201.78a5.4,5.4,0,0,0,2.43-4.22c0-1.56-1.09-2.19-2.43-1.41a5.39,5.39,0,0,0-2.44,4.22C117.78,201.93,118.87,202.55,120.22,201.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.45,161a4,4,0,0,0-1.8,3.12c0,1.15.81,1.62,1.8,1a4,4,0,0,0,1.81-3.12C147.26,160.87,146.45,160.41,145.45,161Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,189.54a4,4,0,0,0-1.8,3.13c0,1.15.81,1.61,1.8,1a4,4,0,0,0,1.8-3.12C97.8,189.44,97,189,96,189.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.45,260.57a4,4,0,0,0-1.8,3.12c0,1.15.81,1.62,1.8,1.05a4,4,0,0,0,1.81-3.13C147.26,260.46,146.45,260,145.45,260.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,289.14a4,4,0,0,0-1.8,3.12c0,1.15.81,1.61,1.8,1a4,4,0,0,0,1.8-3.12C97.8,289,97,288.56,96,289.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4,248.1l8.84,5.1c2.78,1.61,5,.3,5-2.91V223.7a11.13,11.13,0,0,0-5-8.73l-8.84-5.1c-2.78-1.61-5-.31-5,2.91v26.58A11.16,11.16,0,0,0,61.4,248.1Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.72,214.58c0-1.93,1.36-2.72,3-1.75l8.14,4.7a6.68,6.68,0,0,1,3,5.24v4.7l-14.19-8.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.91,248.49c0,1.93-1.35,2.71-3,1.75l-8.14-4.7a6.7,6.7,0,0,1-3-5.24v-4.7l14.19,8.19Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speaker--inject-145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.75,58.25,51.12,85.75a10.32,10.32,0,0,0-4.67,8.09v55.95a10.34,10.34,0,0,0,4.67,8.1L85.61,177.8a10.32,10.32,0,0,0,9.34,0l47.64-27.51a10.32,10.32,0,0,0,4.67-8.09V86.25a10.32,10.32,0,0,0-4.67-8.09L108.1,58.25A10.34,10.34,0,0,0,98.75,58.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.86,177.82c-1.23,0-2-1-2-2.72V119.15a9.66,9.66,0,0,1,4.37-7.56l47.63-27.5a3.63,3.63,0,0,1,1.78-.56c1.24,0,2,1,2,2.72V142.2a9.65,9.65,0,0,1-4.36,7.56L94.64,177.27A3.68,3.68,0,0,1,92.86,177.82Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.67,84.14h0c1.23,0,1.36,1.48,1.36,2.11V142.2a9.12,9.12,0,0,1-4.06,7l-47.63,27.5a3.11,3.11,0,0,1-1.48.48c-1.22,0-1.35-1.48-1.35-2.11V119.15a9.11,9.11,0,0,1,4-7l47.64-27.5a3.11,3.11,0,0,1,1.47-.48m0-1.22a4.25,4.25,0,0,0-2.08.63L95,111.06a10.32,10.32,0,0,0-4.67,8.09V175.1c0,2.11,1,3.34,2.58,3.34A4.28,4.28,0,0,0,95,177.8l47.64-27.51a10.32,10.32,0,0,0,4.67-8.09V86.25c0-2.11-1-3.33-2.59-3.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.61,111.06,51.12,91.15c-2.58-1.49-4.67-.29-4.67,2.69v55.95a10.34,10.34,0,0,0,4.67,8.1L85.6,177.8c2.59,1.49,4.68.28,4.68-2.7V119.15A10.32,10.32,0,0,0,85.61,111.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.1,58.25l34.49,19.91c2.58,1.49,2.58,3.9,0,5.39L95,111.06a10.32,10.32,0,0,1-9.34,0L51.12,91.15c-2.58-1.49-2.58-3.91,0-5.4l47.63-27.5A10.34,10.34,0,0,1,108.1,58.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.77,153.81c10.84-6.26,19.62-21.48,19.62-34s-8.78-17.59-19.62-11.33-19.62,21.47-19.62,34S107.93,160.06,118.77,153.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.77,151.53c9.75-5.63,17.65-19.32,17.65-30.58s-7.9-15.82-17.65-10.19-17.66,19.32-17.66,30.58S109,157.16,118.77,151.53Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.77,143.05c5.69-3.29,10.31-11.28,10.31-17.85s-4.62-9.24-10.31-6-10.31,11.28-10.31,17.85S113.08,146.34,118.77,143.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.77,134.68a6.76,6.76,0,0,0,3.06-5.3c0-1.95-1.37-2.74-3.06-1.77a6.77,6.77,0,0,0-3.06,5.31C115.71,134.87,117.08,135.66,118.77,134.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.16,88.87a3.67,3.67,0,0,0-1.67,2.89c0,1.07.74,1.5,1.67,1a3.68,3.68,0,0,0,1.67-2.89C143.83,88.77,143.08,88.34,142.16,88.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.33,115.34a3.68,3.68,0,0,0-1.67,2.89c0,1.06.75,1.5,1.67,1A3.68,3.68,0,0,0,98,116.3C98,115.24,97.25,114.8,96.33,115.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.16,141.61a3.67,3.67,0,0,0-1.67,2.89c0,1.07.74,1.5,1.67,1a3.71,3.71,0,0,0,1.67-2.9C143.83,141.51,143.08,141.08,142.16,141.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.33,168.08A3.7,3.7,0,0,0,94.66,171c0,1.07.75,1.5,1.67,1A3.68,3.68,0,0,0,98,169C98,168,97.25,167.55,96.33,168.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,130.2v-9.45c0-3,2.09-4.19,4.67-2.7L79,130.37a10.32,10.32,0,0,1,4.67,8.09v9.46c0,3-2.09,4.19-4.67,2.7L57.69,138.3A10.34,10.34,0,0,1,53,130.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.68,147.88c1.55.9,2.81.17,2.81-1.61v-8.71a6.2,6.2,0,0,0-2.81-4.86l-3.77-2.18v15.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,120.78c-1.55-.89-2.8-.17-2.8,1.62v8.71A6.2,6.2,0,0,0,58,136l3.77,2.17V123Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speakers--inject-145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speaker--inject-145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.77,128l-51.32,29.63a11.13,11.13,0,0,0-5,8.72V269.19a11.13,11.13,0,0,0,5,8.72l37.15,21.45a11.1,11.1,0,0,0,10.07,0L442,269.73a11.13,11.13,0,0,0,5-8.72V158.13a11.13,11.13,0,0,0-5-8.72L404.84,128A11.1,11.1,0,0,0,394.77,128Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.67,184.85,442,155.22c2.78-1.6,5-.3,5,2.91V261a11.13,11.13,0,0,1-5,8.72l-51.32,29.63c-2.78,1.61-5,.31-5-2.9V193.57A11.13,11.13,0,0,1,390.67,184.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.6,184.85,343.45,163.4c-2.78-1.61-5-.3-5,2.91V269.19a11.13,11.13,0,0,0,5,8.72l37.15,21.45c2.78,1.61,5,.31,5-2.9V193.57A11.14,11.14,0,0,0,380.6,184.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.84,128,442,149.41c2.78,1.6,2.78,4.21,0,5.81l-51.32,29.63a11.1,11.1,0,0,1-10.07,0L343.45,163.4c-2.78-1.61-2.78-4.21,0-5.81L394.77,128A11.1,11.1,0,0,1,404.84,128Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.33,273.51c11.68-6.74,21.14-23.13,21.14-36.61s-9.46-19-21.14-12.21-21.14,23.14-21.14,36.62S404.66,280.26,416.33,273.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.33,271.07c10.51-6.07,19-20.82,19-32.95s-8.51-17.05-19-11-19,20.81-19,32.95S405.83,277.13,416.33,271.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.33,261.93c6.14-3.54,11.11-12.16,11.11-19.24s-5-9.95-11.11-6.41-11.1,12.15-11.1,19.23S410.2,265.47,416.33,261.93Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.33,252.91a7.29,7.29,0,0,0,3.3-5.71c0-2.1-1.48-3-3.3-1.91A7.31,7.31,0,0,0,413,251C413,253.11,414.51,254,416.33,252.91Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.33,252.91a7.29,7.29,0,0,0,3.3-5.71c0-2.1-1.48-3-3.3-1.91A7.31,7.31,0,0,0,413,251C413,253.11,414.51,254,416.33,252.91Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.33,216.87c8.61-5,15.59-17.06,15.59-27s-7-14-15.59-9-15.59,17.07-15.59,27S407.72,221.84,416.33,216.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.33,215.07c7.75-4.48,14-15.36,14-24.3s-6.28-12.57-14-8.1-14,15.35-14,24.3S408.59,219.54,416.33,215.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.33,208.32c4.53-2.61,8.19-9,8.19-14.18s-3.66-7.34-8.19-4.73-8.19,9-8.19,14.19S411.81,210.93,416.33,208.32Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.33,201.68a5.39,5.39,0,0,0,2.44-4.22c0-1.55-1.09-2.18-2.44-1.4a5.37,5.37,0,0,0-2.43,4.21C413.9,201.82,415,202.45,416.33,201.68Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.33,201.68a5.39,5.39,0,0,0,2.44-4.22c0-1.55-1.09-2.18-2.44-1.4a5.37,5.37,0,0,0-2.43,4.21C413.9,201.82,415,202.45,416.33,201.68Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.53,161a4,4,0,0,0-1.8,3.11c0,1.15.81,1.61,1.8,1a4,4,0,0,0,1.8-3.12C443.33,160.84,442.52,160.37,441.53,161Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.16,189.46a4,4,0,0,0-1.8,3.12c0,1.15.81,1.61,1.8,1a4,4,0,0,0,1.8-3.12C394,189.35,393.15,188.89,392.16,189.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.53,260.37a4,4,0,0,0-1.8,3.12c0,1.15.81,1.61,1.8,1a4,4,0,0,0,1.8-3.12C443.33,260.27,442.52,259.8,441.53,260.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.16,288.89a4,4,0,0,0-1.8,3.12c0,1.15.81,1.61,1.8,1a4,4,0,0,0,1.8-3.12C394,288.78,393.15,288.32,392.16,288.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.62,247.92l8.82,5.09c2.78,1.61,5,.31,5-2.9V223.56a11.13,11.13,0,0,0-5-8.72l-8.82-5.09c-2.78-1.61-5-.3-5,2.91V239.2A11.12,11.12,0,0,0,357.62,247.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.94,214.45c0-1.92,1.36-2.7,3-1.74l8.13,4.69a6.67,6.67,0,0,1,3,5.23v4.69l-14.17-8.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.11,248.31c0,1.93-1.35,2.71-3,1.74L358,245.36a6.66,6.66,0,0,1-3-5.23v-4.69l14.17,8.18Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speaker--inject-145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.62,58.25,347.06,85.7a10.33,10.33,0,0,0-4.66,8.08v55.86a10.32,10.32,0,0,0,4.66,8.08l34.43,19.88a10.3,10.3,0,0,0,9.33,0l47.56-27.46a10.29,10.29,0,0,0,4.66-8.08V86.2a10.31,10.31,0,0,0-4.66-8.08L404,58.25A10.3,10.3,0,0,0,394.62,58.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.82,111l47.56-27.46C441,82,443,83.23,443,86.2v55.86a10.29,10.29,0,0,1-4.66,8.08L390.82,177.6c-2.57,1.49-4.66.28-4.66-2.69V119.05A10.32,10.32,0,0,1,390.82,111Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.49,111,347.06,91.09c-2.57-1.49-4.66-.28-4.66,2.69v55.86a10.32,10.32,0,0,0,4.66,8.08l34.43,19.88c2.58,1.49,4.67.28,4.67-2.69V119.05A10.3,10.3,0,0,0,381.49,111Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,58.25l34.43,19.87c2.58,1.49,2.58,3.9,0,5.39L390.82,111a10.3,10.3,0,0,1-9.33,0L347.06,91.09c-2.57-1.49-2.57-3.9,0-5.39l47.56-27.45A10.3,10.3,0,0,1,404,58.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.6,153.65c10.82-6.25,19.59-21.44,19.59-33.93s-8.77-17.56-19.59-11.31S395,129.84,395,142.34,403.78,159.89,414.6,153.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.6,151.38c9.74-5.62,17.63-19.29,17.63-30.53s-7.89-15.8-17.63-10.18S397,130,397,141.2,404.87,157,414.6,151.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.6,142.91c5.68-3.28,10.29-11.26,10.29-17.83s-4.61-9.22-10.29-5.94S404.31,130.4,404.31,137,408.92,146.19,414.6,142.91Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.6,134.56a6.77,6.77,0,0,0,3.06-5.3c0-1.95-1.37-2.74-3.06-1.76a6.74,6.74,0,0,0-3.06,5.29C411.54,134.74,412.91,135.53,414.6,134.56Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.6,134.56a6.77,6.77,0,0,0,3.06-5.3c0-1.95-1.37-2.74-3.06-1.76a6.74,6.74,0,0,0-3.06,5.29C411.54,134.74,412.91,135.53,414.6,134.56Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,88.82a3.68,3.68,0,0,0-1.67,2.88c0,1.07.75,1.5,1.67,1a3.71,3.71,0,0,0,1.67-2.89C439.62,88.71,438.87,88.28,438,88.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.2,115.24a3.7,3.7,0,0,0-1.67,2.89c0,1.06.75,1.49,1.67,1a3.68,3.68,0,0,0,1.67-2.89C393.87,115.14,393.12,114.71,392.2,115.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,141.47a3.68,3.68,0,0,0-1.67,2.89c0,1.06.75,1.49,1.67,1a3.68,3.68,0,0,0,1.67-2.89C439.62,141.37,438.87,140.94,438,141.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.2,167.9a3.68,3.68,0,0,0-1.67,2.88c0,1.07.75,1.5,1.67,1a3.71,3.71,0,0,0,1.67-2.89C393.87,167.79,393.12,167.36,392.2,167.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349,130.08v-9.44c0-3,2.09-4.18,4.67-2.69l21.3,12.3a10.31,10.31,0,0,1,4.66,8.08v9.44c0,3-2.09,4.18-4.66,2.69l-21.3-12.3A10.29,10.29,0,0,1,349,130.08Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.58,147.74c1.55.89,2.8.16,2.8-1.62v-8.7a6.17,6.17,0,0,0-2.8-4.84l-3.76-2.18v15.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,120.68c-1.54-.89-2.79-.17-2.79,1.62V131a6.19,6.19,0,0,0,2.79,4.85l3.77,2.17V122.85Z",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.12,360.92a14.4,14.4,0,0,0,12.47,0l5.46-36-18.25-1Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,358.1a9.27,9.27,0,0,0-.92,5.14c.15,1.54,1.24,3.49.92,7s-1.12,4.62-1.42,7.09a9.48,9.48,0,0,0,1.62,7.13c1.65,2.29,5.33,4.1,12.11,3.64,5.47-.37,7.79-3.21,7.79-6.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.56,353.28a1.57,1.57,0,0,0-.77.51c-.55.67-.36,1.7-.53,2.5-.07.3-.14.61-.19.92-.44,2.34.19,4.73.25,7.1a37.72,37.72,0,0,1-1.25,8.34c-1,5-1,8.06,3.78,11.31,2.53,1.71,5.14,1.89,8.26,1.85,2.37,0,5.62-.59,6.8-1.77,1.53-1.52,1.88-2.57,1.87-3,0-5.24-2.31-11.25-2.93-16.46-.32-2.6-.23-5.25-.39-7.87a.94.94,0,0,0-.16-.56,1.1,1.1,0,0,0-.48-.25,25.29,25.29,0,0,0-11.83-.39c-.33.06-.71.16-.83.45a.82.82,0,0,0,0,.38,10.51,10.51,0,0,1-.21,2.09c0,.16-.13.37-.31.37s-.48-1.46-.5-1.63l0-3.94A1.92,1.92,0,0,0,139.56,353.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.33,380.17a6.09,6.09,0,0,0-.91-3.17c-2.78-4.6-16.73-4.27-20.9.57.14,2.91.55,4.54,3.51,6.57,2.43,1.66,6.24,1.88,9.36,1.85,2.36,0,5.46-.84,6.83-2C157.83,382.71,158.29,382.08,158.33,380.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.54,355.82c2.92,5.82,7.49,3.48,13.42-.25l2.89-38.38-18.27,4.55Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.06,369.11a3.63,3.63,0,0,1-.17,2.87c-.43.84-5.19,3.32-11.6,2.92A28.19,28.19,0,0,1,189,370.62c-2.44-1.5-5-1.78-8.16-1.94s-7.35-1.63-8.05-3,.11-3.73.11-3.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.76,353.33c1.41,2.53,4.62,3.82,7.17,5.11,1.13.58,2.42,1.08,3.59,1.61,1.55.71,3.19.95,4.77,1.53a28.21,28.21,0,0,1,5.1,2.3c2.51,1.57,2.84,5.51,0,7.06-2.47,1.34-9,2.79-15.81,1-3.71-1-7.84-4.64-12.72-5-3.11-.22-9-1-11-3.2-.64-3.17.24-4,1-6.67.39-1.26.4-2.57.73-3.82a1.35,1.35,0,0,1,.57-1,3.34,3.34,0,0,1,1.07-.43l.1,1.44s.22.65,2,1.56a7.24,7.24,0,0,1,2.79,2.55,2.71,2.71,0,0,0,.65.85.88.88,0,0,0,1,.07c.28-.24.24-.65.2-1a19.86,19.86,0,0,1-.18-2.43.81.81,0,0,1,.07-.41,1,1,0,0,1,.29-.28,15.44,15.44,0,0,1,6.94-2,1.55,1.55,0,0,1,.91.09,1.57,1.57,0,0,1,.56.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.37,355.15a16.39,16.39,0,0,1-.46,1.93c-.81,2.64-1.69,3.5-1,6.67,1.53,1.67,5.35,2.53,8.44,2.94C182.35,361.28,178.68,357.23,174.37,355.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.51,363.67a26.06,26.06,0,0,0-4.52-1.83c-7.91.78-10.55,7.29-10.14,10.41,6.24,1.58,12.26.11,14.58-1.15C215.3,369.55,215,365.24,212.51,363.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.75,207.15c-.8,22.55-2.18,37.7-2.09,79.21a170.34,170.34,0,0,0-2.35,22.71c-.31,10.39.67,37.57.67,37.57a21.6,21.6,0,0,0,15.1.46s6.7-40,9.12-54.47c2.13-12.73,5.31-37.67,5.31-37.67l3,33a199.53,199.53,0,0,0,.53,20.23c.52,6.81,2.62,34.62,2.62,34.62s6.37,5,15.26.66c0,0,5.07-51.24,5.2-57.42.14-7-2.83-85.15-2.83-85.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.92,287.9c-4.77-1.67-13.19,1.64-13.19,1.64s-.41.49,0,.79a17.08,17.08,0,0,0,9.34,3.14c5.85.38,7.57-1.66,7.57-1.66S164.69,289.57,159.92,287.9Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.25,292a17,17,0,0,0,8.57,2.75c4.7,0,6.09-.5,6.09-.5s-1.69,1.6-6.29,1.32A15.8,15.8,0,0,1,147.25,292Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.74,288.33s-2.78-3.47-12.3-1.31c0,0,4.26-2.23,8-1.51S163.74,288.33,163.74,288.33Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.17,288.33a40,40,0,0,1,13-2.94,49,49,0,0,1-.31,5.53s-8.25.71-11.68-.27C184.17,290.65,181.57,290.05,183.17,288.33Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.67,291s1.62.9,6,1.17a90.57,90.57,0,0,0,9.32,0,23.7,23.7,0,0,1-8.72,1.27C181.23,293.29,179.67,291,179.67,291Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.51,255l3.43-20.73s9.63-1.11,15.17-6.28c0,0,0,5.24-11.65,9.24l-4.07,19.41.16,31.37Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.67,202.34c-6.09-3-6.34-5-10.56-14s-11.32-24.47-11.32-24.47l.43-22c11-.5,15,4.57,17.63,17.18,3.5,8.85,12.06,27.95,12.06,27.95",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.28,144.84s-6.91.06-7.84,11.35c-.86,10.53,1.48,17,2.45,33.45L142.65,219c11.37,3.18,38.88,6.94,51.93-2,0,0-.27-41.84-2.26-54.19-2.27-14.13-7.4-21.08-12.4-20.87l-20.06.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.27,126.48c2.16,3.56,15.41,24.39,22.65,35,2.3,3.38,5.52,7.65,6.36,11.66l.33,2.66c8.06-3.73,13.19-17.71,8.06-31.31-2.67-4.26-5.14-5.59-7.18-7.93-5.55-7.13-13.8-20.51-13.8-20.51s-1.15-29.43.48-37.93c.29-1.48,2.51-2.21,3.71-3.13,3.26-2.52,4-4.19,6.34-7.18,1.84-2.35,3.54-3.06,3.2-3.72-.43-.84-2-2.12-4.47-1.1-.68.28-4.48,3.3-4.2,1.2a6.66,6.66,0,0,1,.92-2,61.59,61.59,0,0,1,4.71-6.46c.68-.92,1.54-1.74,2.27-2.62.88-1.07,4.71-5.27,1.95-6.44-.66-.28-1.23.19-1.75.53-1,.7-2.22,1.15-3.31,1.78a41.15,41.15,0,0,0-3.7,2.41,8.61,8.61,0,0,1-3.79,1.6,14.81,14.81,0,0,0-3.9,1.12c-1.31.74-2,2.06-3.29,2.88-1.57,1-3.23,1.6-4.55,3-1.88,2-2.53,4.2-3.15,6.87a138.39,138.39,0,0,0-2.52,15c-1.54,11.9-3.84,24.28-4.34,33.24C109.07,119.41,108.88,120.9,112.27,126.48Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.48,83.19c-.16,1.18-.32,2.37-.49,3.55a12.46,12.46,0,0,0,4.48,2.05,18.56,18.56,0,0,0,4.62.57,15.63,15.63,0,0,0,6.3-1.22c0-1.16.08-2.29.13-3.35C126.29,86.45,122,87,118.17,86A7.57,7.57,0,0,1,113.48,83.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.57,95.61a20.26,20.26,0,0,0,4.94.6,16.72,16.72,0,0,0,6.79-1.32q0-1.77,0-3.51c-2.42,1.73-7,2.31-11,1.28a8.8,8.8,0,0,1-4.8-2.7c-.17,1.21-.35,2.4-.53,3.6A13.81,13.81,0,0,0,116.57,95.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.67,66c.1,3.17-.65,8.23-4.75,10.32C126.77,75.64,128.72,71.57,126.67,66Z",
    style: {
      fill: "#f28f8f"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.37,104.32a4.23,4.23,0,0,1,2.33-4.19c.48-.25,7.76-6.64,7.76-6.64l1.31-1.83c-.4-.46-10.35,2.74-11.58,5.25C150.24,98.85,150.47,102.07,151.37,104.32Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M186.6,105.6c1.42,2.74,1.39,8.33-2,11.48-4.29,4-3.82-11.58-3.82-11.58A6,6,0,0,1,186.6,105.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.39,104a5.31,5.31,0,0,0-4.36,1.69c-1.83,2-.59,8,1.95,13.87l6.47,14-.36-7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,120.41c-.79-.91-.7-1.72-1.81-2.81s-5.5-2.36-7.13,1.37,1.8,8.64,4.58,9.42c4.79,1.34,5.41-1.72,5.41-1.72l.89,17.1c4.23,4.44,19.32,7.49,15.42-.93l-.18-5.21a26,26,0,0,0,6.88-.54c2.32-.67,4.49-2.27,5.72-7.7,1.54-6.78,1.15-14.49-.45-23-2.17-11.61-16.21-11.49-24.27-6.07S156,120.41,156,120.41Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,101c1.72-4.07,5.66-6.86,9.82-8.32a20.94,20.94,0,0,1,12.9-.54,12,12,0,0,1,7.72,6.23,6.08,6.08,0,0,1,.76,4.2c-.73,4.84-8,6.07-11.9,5.44-2-.31-4.18-.5-5.93-1.48-.32-.18-1.19-1-1.6-1s-1.09,1.32-1.33,1.62c-.46.58-.8,1.19-1.44,1.47a10.79,10.79,0,0,1-2.41.36c-.78.12-.86,0-1,.94-.22,1.52,0,3.16,0,4.7,0,1.14.11,2.29,0,3.44,0,.75-.09,1.79-.75,2.28a1.59,1.59,0,0,1-1.87.06,3.08,3.08,0,0,1-.88-1.69,6.42,6.42,0,0,0-.56-1.39C150.37,109.53,151.79,103.82,153,101Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.22,137.63s-7.83-1.33-10.6-2.69a9,9,0,0,1-3.88-3.61,12.39,12.39,0,0,0,2.28,4.33c2.07,2.48,12.27,4,12.27,4Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.83,117.1a1.57,1.57,0,1,1-1.62-1.58A1.6,1.6,0,0,1,170.83,117.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.78,110.42,166.3,112a2,2,0,0,1,1-2.58A1.86,1.86,0,0,1,169.78,110.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.74,126.31l6.35,2.16a3.29,3.29,0,0,1-4.2,2.21A3.52,3.52,0,0,1,168.74,126.31Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.88,127.77a2.83,2.83,0,0,1,3.13,2.5,2.72,2.72,0,0,1,0,.57,3.13,3.13,0,0,1-1.12-.16,3.44,3.44,0,0,1-2.27-2.86Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,111.27l-3.67-1.16a1.85,1.85,0,0,1,2.35-1.29A2,2,0,0,1,185,111.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.51,116.76a1.58,1.58,0,0,1-1.51,1.66,1.62,1.62,0,1,1,1.51-1.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.23 115.29 175.5 124.63 180.34 123.95 175.23 115.29",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cap--inject-145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187,106.23l-.13,0c-7.71-1.66-17.05,0-24.7,3.87l-.75.38h0a34.11,34.11,0,0,0-9.27,6.18,4.86,4.86,0,0,0-3.61.51c-.11-.46-.57-2.86-.63-3.23-1.57-10.43.09-17.56,16.16-22.23,11.17-3.25,19.81,1.81,21.84,8.74C186.37,101.91,186.65,104.66,187,106.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.23,109a21.58,21.58,0,0,1,8.08-8c3.8-2.3,11.82-2.84,15.42-3,6.3-.24,7.88,1,8,1.94,0,.22.17,1.24.21,1.47a.91.91,0,0,1-.1.6c-.87,1.48-5.82,4.23-5.82,4.23-8-1.76-17.75,0-25.57,4.22Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.46,110.45A41.46,41.46,0,0,1,187,106.23s4.95-2.75,5.82-4.23c.46-.82-.1-2.81-7.9-2.52-3.6.14-11.61.67-15.41,3A21.39,21.39,0,0,0,161.46,110.45Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190,111.92l-.79-.06c-2.56-.16-6,.4-12.67.76-5.73.32-10.89.07-13.61.48l-.85.13a1.43,1.43,0,0,0-.93,1.48,3,3,0,0,0,.84,1.62,2.38,2.38,0,0,1,.27.66,29.55,29.55,0,0,0,1.09,4.54,5.14,5.14,0,0,0,1.09,1.59,5,5,0,0,0,.56.47l.32.2a4.61,4.61,0,0,0,.95.42l.16,0,.25.07.27.05c.26,0,.54.08.84.1h.81a6,6,0,0,0,5.74-3.68c.84-1.78.59-4.22,2.2-4.3h.15l.14,0c1.19.23,1.06,2.48,1.82,4.08a6.51,6.51,0,0,0,1.16,1.72,3.31,3.31,0,0,0,.27.26l.14.12.15.12.15.1.15.1.11.06.09.05a5,5,0,0,0,1.38.51h.13a6.52,6.52,0,0,0,1.69.1,5.09,5.09,0,0,0,4.87-3.41,30.37,30.37,0,0,0,1-4.64,1.48,1.48,0,0,1,.28-.62,3.2,3.2,0,0,0,.72-1.72C190.9,112.6,190.42,112,190,111.92Zm-16.57,7.27a5.46,5.46,0,0,1-1.18,2.48,4.94,4.94,0,0,1-3.78,1.56,4,4,0,0,1-3.64-1.59c-.05-.06-.08-.12-.12-.17a1.63,1.63,0,0,1-.11-.17l-.1-.16a.61.61,0,0,0-.07-.14l0-.12-.06-.09c0-.06-.05-.12-.07-.17l-.19-.51h0c0-.1-.07-.2-.09-.3l-.13-.48s0-.07,0-.1a.28.28,0,0,1,0-.09c-.29-1.2-.63-3.58,0-4.14s2.16-1.2,4.75-1.07l.28,0a11.7,11.7,0,0,1,1.17.15l.47.09a11,11,0,0,1,1.14.33l.36.14a3.34,3.34,0,0,1,.38.16.11.11,0,0,0,.08,0l.14.09a2.13,2.13,0,0,1,.78.6C173.82,116.24,173.69,117.83,173.41,119.19ZM188.46,118c-.19,1-.6,3-2.4,4a4.73,4.73,0,0,1-1.92.52,4.06,4.06,0,0,1-3.88-1.64s0,0,0,0l-.07-.11a.5.5,0,0,0-.08-.12.19.19,0,0,1,0-.08.75.75,0,0,1-.1-.17c-.05-.09-.07-.16-.11-.23l-.05-.11s0,0,0-.06a.25.25,0,0,1,0-.09.19.19,0,0,1,0-.07,4.77,4.77,0,0,1-.26-.89c-.28-1.34-.44-2.91,0-3.68s2.37-1.68,4.2-2a11.72,11.72,0,0,1,1.19-.15h1l.32,0a5.13,5.13,0,0,1,.6.08l.14,0h0l.09,0,.15,0,.17,0,.28.11,0,0a2.2,2.2,0,0,1,.64.38C189,114.33,188.7,116.74,188.46,118Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.46,118c-.19,1-.6,3-2.4,4a4.73,4.73,0,0,1-1.92.52,4.06,4.06,0,0,1-3.88-1.64s0,0,0,0l-.07-.11a.5.5,0,0,0-.08-.12.19.19,0,0,1,0-.08.75.75,0,0,1-.1-.17c-.05-.09-.07-.16-.11-.23l-.05-.11s0,0,0-.06a.25.25,0,0,1,0-.09.19.19,0,0,1,0-.07,4.77,4.77,0,0,1-.26-.89c-.28-1.34-.44-2.91,0-3.68s2.37-1.68,4.2-2a11.72,11.72,0,0,1,1.19-.15h1l.32,0a5.13,5.13,0,0,1,.6.08l.14,0h0l.09,0,.15,0,.17,0,.28.11,0,0a2.2,2.2,0,0,1,.64.38C189,114.33,188.7,116.74,188.46,118Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.41,119.19a5.46,5.46,0,0,1-1.18,2.48,4.94,4.94,0,0,1-3.78,1.56,4,4,0,0,1-3.64-1.59c-.05-.06-.08-.12-.12-.17a1.63,1.63,0,0,1-.11-.17l-.1-.16a.61.61,0,0,0-.07-.14l0-.12-.06-.09c0-.06-.05-.12-.07-.17l-.19-.51h0c0-.1-.07-.2-.09-.3l-.13-.48s0-.07,0-.1a.28.28,0,0,1,0-.09c-.29-1.2-.63-3.58,0-4.14s2.16-1.2,4.75-1.07l.28,0a11.7,11.7,0,0,1,1.17.15l.47.09a11,11,0,0,1,1.14.33l.36.14a3.34,3.34,0,0,1,.38.16.11.11,0,0,0,.08,0l.14.09a2.13,2.13,0,0,1,.78.6C173.82,116.24,173.69,117.83,173.41,119.19Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.37,93a16.28,16.28,0,0,0-6.61,3.64c-2.62,2.57-2.4,5-2.1,7.69s2.67,10.86,2.67,10.86l5.92-.48s-4.71-12.5-4.4-15.56c.29-2.91,3.25-4.19,5-4.93A43.93,43.93,0,0,1,161,92.67a39.8,39.8,0,0,1,5.72-1.61C162.85,90.41,157.84,92.14,155.37,93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.75,126.35a13.93,13.93,0,0,0-3.46-12.13,5.93,5.93,0,0,0-2.63-1.58,3.59,3.59,0,0,0-1.87,0l-2,.58c-1.38.41-2.48,1.72-3,3.71a14,14,0,0,0,3.46,12.13,6,6,0,0,0,2.63,1.58,3.66,3.66,0,0,0,1.89,0l2-.57C158.15,129.66,159.25,128.34,159.75,126.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.85,130.65a6,6,0,0,1-2.63-1.58,14,14,0,0,1-3.46-12.13c.71-2.83,2.62-4.29,4.87-3.72a5.89,5.89,0,0,1,2.63,1.58,13.93,13.93,0,0,1,3.46,12.13C157,129.75,155.1,131.21,152.85,130.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.28,126.82a13.42,13.42,0,0,0-3.33-11.7c-1.39-1.35-2.85-1.81-4.07-1.46l-1,.29c-1.22.35-2.21,1.5-2.69,3.39A13.43,13.43,0,0,0,149.52,129c1.39,1.35,2.84,1.81,4.06,1.46l1-.29C155.82,129.85,156.81,128.7,157.28,126.82Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.94,115.41a13.48,13.48,0,0,1,3.33,11.7c-1,3.76-4,4.62-6.75,1.92a13.43,13.43,0,0,1-3.34-11.69C147.13,113.57,150.15,112.71,152.94,115.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.27,127.11a13.48,13.48,0,0,0-3.33-11.7c-1.4-1.35-2.85-1.8-4.07-1.46l-1.3.42c-1.23.35-2.22,1.5-2.69,3.38a13.45,13.45,0,0,0,3.34,11.7c1.39,1.34,2.84,1.8,4.06,1.46l1.3-.42C154.8,130.14,155.8,129,156.27,127.11Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.63,115.83A13.43,13.43,0,0,1,155,127.52c-.95,3.76-4,4.63-6.75,1.93a13.45,13.45,0,0,1-3.34-11.7C145.83,114,148.85,113.13,151.63,115.83Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.1,119.39a7.1,7.1,0,0,1,1.75,6.15c-.5,2-2.09,2.42-3.55,1a7.07,7.07,0,0,1-1.75-6.15C147.05,118.43,148.63,118,150.1,119.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.33,121.64,149,123l-1.24-4.34a2.25,2.25,0,0,1,2.14.77A6.32,6.32,0,0,1,151.33,121.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.69,125.58a2.25,2.25,0,0,1-1.41,1.78L149,123l2.29-1.37A6.86,6.86,0,0,1,151.69,125.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.28,127.36a2.26,2.26,0,0,1-2.14-.77,6.18,6.18,0,0,1-1.39-2.21L149,123Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,123l-2.29,1.37a6.9,6.9,0,0,1-.36-3.93,2.26,2.26,0,0,1,1.41-1.78Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.31,237a2.72,2.72,0,0,0-1.61-2.24L302.39,193a8.56,8.56,0,0,0-7.76,0L109.22,300a2.72,2.72,0,0,0-1.6,2.25v69.33a2.72,2.72,0,0,0,1.6,2.24l72.32,41.75a8.56,8.56,0,0,0,7.76,0l185.4-107a2.72,2.72,0,0,0,1.61-2.24Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.31,237v69.33a2.69,2.69,0,0,1-1.61,2.24l-185.4,107a8,8,0,0,1-3.88.93V347.21a7.92,7.92,0,0,0,3.88-.93l185.4-107A2.72,2.72,0,0,0,376.31,237Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.42,347.21v69.33a7.87,7.87,0,0,1-3.88-.93l-72.32-41.75a2.71,2.71,0,0,1-1.6-2.24V302.28a2.69,2.69,0,0,0,1.6,2.24l72.32,41.76A7.87,7.87,0,0,0,185.42,347.21Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.22,300,294.63,193a8.56,8.56,0,0,1,7.76,0l72.31,41.75c2.15,1.24,2.15,3.24,0,4.48l-185.41,107a8.54,8.54,0,0,1-7.75,0l-72.32-41.75C107.08,303.29,107.08,301.28,109.22,300Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.22,300,294.63,193a8.56,8.56,0,0,1,7.76,0l72.31,41.75c2.15,1.24,2.15,3.24,0,4.48l-185.41,107a8.54,8.54,0,0,1-7.75,0l-72.32-41.75C107.08,303.29,107.08,301.28,109.22,300Z",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.35,304.59l67.19,38.79a8.62,8.62,0,0,0,7.76,0L369.59,239.31a3.46,3.46,0,0,0,1.73-3V230.7L185.44,338l-72.79-42,0,5.61A3.45,3.45,0,0,0,114.35,304.59Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.42,338v6.32a7.92,7.92,0,0,0,3.88-.93L369.59,239.31a3.46,3.46,0,0,0,1.73-3V230.7L185.44,338Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.31,218.1a2.69,2.69,0,0,0-1.61-2.24l-72.31-41.75a8.56,8.56,0,0,0-7.76,0l-185.41,107a2.72,2.72,0,0,0-1.6,2.24V296a2.72,2.72,0,0,0,1.6,2.24L181.54,340a8.56,8.56,0,0,0,7.76,0l185.4-107a2.72,2.72,0,0,0,1.61-2.24Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.31,218.09V230.7a2.7,2.7,0,0,1-1.61,2.24L189.3,340a8,8,0,0,1-3.88.92V328.3a7.93,7.93,0,0,0,3.88-.94l185.4-107A2.69,2.69,0,0,0,376.31,218.09Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.42,328.3v12.59a7.87,7.87,0,0,1-3.88-.92l-72.32-41.75a2.72,2.72,0,0,1-1.6-2.24V283.37a2.7,2.7,0,0,0,1.6,2.24l72.32,41.75A7.87,7.87,0,0,0,185.42,328.3Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.22,281.13l185.41-107a8.56,8.56,0,0,1,7.76,0l72.31,41.75c2.15,1.23,2.15,3.24,0,4.48l-185.41,107a8.54,8.54,0,0,1-7.75,0l-72.32-41.75C107.08,284.37,107.08,282.37,109.22,281.13Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.22,281.13l185.41-107a8.56,8.56,0,0,1,7.76,0l72.31,41.75c2.15,1.23,2.15,3.24,0,4.48l-185.41,107a8.54,8.54,0,0,1-7.75,0l-72.32-41.75C107.08,284.37,107.08,282.37,109.22,281.13Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Audio--inject-145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.21,361.05a.8.8,0,0,1-.8-.81v-2.81a.81.81,0,1,1,1.61,0v2.81A.81.81,0,0,1,228.21,361.05Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.27,366.66a.81.81,0,0,1-.81-.81V347.14a.81.81,0,0,1,1.62,0v18.71A.81.81,0,0,1,232.27,366.66Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.32,360.09a.81.81,0,0,1-.81-.81V349a.81.81,0,1,1,1.62,0v10.25A.81.81,0,0,1,236.32,360.09Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.43,352.68a.81.81,0,0,1-.81-.81v-4.79a.81.81,0,0,1,1.62,0v4.79A.81.81,0,0,1,244.43,352.68Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.48,354a.8.8,0,0,1-.8-.81V341.1a.81.81,0,0,1,1.61,0v12.06A.81.81,0,0,1,248.48,354Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.54,360.35a.81.81,0,0,1-.81-.81V330a.81.81,0,0,1,1.61,0v29.5A.8.8,0,0,1,252.54,360.35Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.59,355a.81.81,0,0,1-.81-.81V330.74a.81.81,0,0,1,1.62,0v23.42A.81.81,0,0,1,256.59,355Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.64,357.78a.8.8,0,0,1-.8-.8V323.25a.81.81,0,1,1,1.61,0V357A.8.8,0,0,1,260.64,357.78Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.7,346.67a.81.81,0,0,1-.81-.81V329.68a.81.81,0,0,1,1.62,0v16.18A.81.81,0,0,1,264.7,346.67Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.75,338.17a.81.81,0,0,1-.81-.81V333.5a.81.81,0,0,1,1.62,0v3.86A.81.81,0,0,1,268.75,338.17Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.86,342.63a.81.81,0,0,1-.81-.81V319.68a.81.81,0,1,1,1.62,0v22.14A.81.81,0,0,1,276.86,342.63Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,343.68a.8.8,0,0,1-.81-.8V309.26a.81.81,0,1,1,1.61,0v33.62A.8.8,0,0,1,285,343.68Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.07,324.59a.8.8,0,0,1-.8-.81V319a.81.81,0,0,1,1.61,0v4.79A.81.81,0,0,1,293.07,324.59Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.51,300.25a.8.8,0,0,1-.8-.8v-2.82a.81.81,0,0,1,1.61,0v2.82A.8.8,0,0,1,333.51,300.25Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.46,310.55a.81.81,0,0,1-.81-.81V291a.81.81,0,0,1,1.62,0v18.72A.81.81,0,0,1,329.46,310.55Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.41,308.66a.81.81,0,0,1-.81-.81V297.59a.81.81,0,0,1,1.61,0v10.26A.8.8,0,0,1,325.41,308.66Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.3,310.6a.8.8,0,0,1-.81-.8V305a.81.81,0,0,1,1.62,0v4.79A.8.8,0,0,1,317.3,310.6Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.25,316.58a.81.81,0,0,1-.81-.81V303.71a.81.81,0,0,1,1.61,0v12.06A.8.8,0,0,1,313.25,316.58Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.19,327.64a.81.81,0,0,1-.81-.81v-29.5a.81.81,0,0,1,1.62,0v29.5A.81.81,0,0,1,309.19,327.64Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.08,334.44a.81.81,0,0,1-.8-.81V299.9a.81.81,0,1,1,1.61,0v33.73A.81.81,0,0,1,301.08,334.44Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,326.2a.81.81,0,0,1-.81-.81V312.82a.81.81,0,1,1,1.62,0v12.57A.81.81,0,0,1,297,326.2Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.38,367.62a.81.81,0,0,1-.81-.81v-30a.81.81,0,1,1,1.61,0v30A.8.8,0,0,1,240.38,367.62Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.81,338a.81.81,0,0,1-.81-.81V329a.81.81,0,1,1,1.61,0v8.22A.8.8,0,0,1,272.81,338Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.91,352.12a.8.8,0,0,1-.8-.81v-45.8a.81.81,0,1,1,1.61,0v45.8A.81.81,0,0,1,280.91,352.12Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,332.37a.81.81,0,0,1-.81-.81V315.89a.81.81,0,0,1,1.62,0v15.67A.81.81,0,0,1,289,332.37Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.35,320.87a.81.81,0,0,1-.8-.81v-30a.81.81,0,1,1,1.61,0v30A.81.81,0,0,1,321.35,320.87Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.14,326.94a.81.81,0,0,1-.81-.81V302.71a.81.81,0,0,1,1.62,0v23.42A.81.81,0,0,1,305.14,326.94Z",
    style: {
      fill: "#6B9ADF"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Controller--inject-145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.47,258.3a.58.58,0,0,0,0-1l-49.79-28.74a2.91,2.91,0,0,0-2.91,0l-109,62.79a.65.65,0,0,0,0,1.12l50,28.88a2.3,2.3,0,0,0,2.27,0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.8 306.48 134.48 279.17 240.03 218.23 287.35 245.54 181.8 306.48",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.48 279.17 134.48 291.77 181.8 319.09 181.8 306.48 134.48 279.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.35 245.54 287.35 258.15 181.8 319.09 181.8 306.48 287.35 245.54",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.43,287.06a.22.22,0,0,1-.2-.12.23.23,0,0,1,.09-.32l25.48-14.71a.24.24,0,0,1,.23.41L223.55,287A.27.27,0,0,1,223.43,287.06Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.43,289.17a.24.24,0,0,1-.2-.12.22.22,0,0,1,.09-.32L248.8,274a.24.24,0,0,1,.32.09.23.23,0,0,1-.09.32l-25.48,14.72A.27.27,0,0,1,223.43,289.17Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.43,291.27a.22.22,0,0,1-.2-.12.23.23,0,0,1,.09-.32l25.48-14.71a.23.23,0,0,1,.32.09.23.23,0,0,1-.09.32l-25.48,14.71Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.16,298.64a.24.24,0,0,1-.12,0l-2.63-1.49a.24.24,0,0,1-.12-.21.24.24,0,0,1,.12-.2l5.74-3.26a.24.24,0,0,1,.23,0l2.58,1.46a.22.22,0,0,1,.12.21.22.22,0,0,1-.12.2l-5.69,3.29A.2.2,0,0,1,191.16,298.64ZM189,296.91l2.14,1.22,5.22-3-2.1-1.2Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.07,292.33a.2.2,0,0,1-.11,0l-2.63-1.49a.23.23,0,0,1,0-.4l5.74-3.26a.2.2,0,0,1,.23,0l2.58,1.46a.24.24,0,0,1,.12.2.22.22,0,0,1-.12.21l-5.69,3.28Zm-2.15-1.72,2.15,1.22,5.22-3-2.1-1.2Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,286a.2.2,0,0,1-.11,0l-2.63-1.49a.24.24,0,0,1-.12-.2.24.24,0,0,1,.12-.21l5.74-3.26a.24.24,0,0,1,.23,0l2.58,1.46a.26.26,0,0,1,.12.21.22.22,0,0,1-.12.2L213.11,286Zm-2.15-1.72,2.15,1.21,5.22-3-2.11-1.19Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.12,275.52l-.12,0L148.38,274a.22.22,0,0,1-.12-.2.24.24,0,0,1,.12-.21l5.74-3.26a.24.24,0,0,1,.23,0l2.58,1.47a.24.24,0,0,1,.12.2.26.26,0,0,1-.12.21l-5.69,3.28ZM149,273.8l2.15,1.22,5.22-3-2.11-1.19Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,269.22l-.12,0-2.62-1.49a.22.22,0,0,1-.12-.2.22.22,0,0,1,.12-.21L165,264a.26.26,0,0,1,.24,0l2.57,1.46a.24.24,0,0,1,.12.21.23.23,0,0,1-.11.2l-5.69,3.29Zm-2.15-1.72,2.15,1.21,5.22-3-2.11-1.19Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,262.92a.27.27,0,0,1-.12,0l-2.62-1.49a.24.24,0,0,1-.12-.21.22.22,0,0,1,.12-.2l5.73-3.26a.24.24,0,0,1,.23,0l2.58,1.46a.22.22,0,0,1,.12.2.24.24,0,0,1-.11.21l-5.7,3.28A.15.15,0,0,1,173,262.92Zm-2.15-1.73,2.15,1.22,5.21-3-2.1-1.2Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.76,267.07l-.12,0L243,265.55a.23.23,0,0,1-.11-.2.24.24,0,0,1,.11-.21l5.74-3.26a.24.24,0,0,1,.23,0l2.58,1.47a.21.21,0,0,1,.12.2.22.22,0,0,1-.12.2L245.87,267A.2.2,0,0,1,245.76,267.07Zm-2.15-1.72,2.14,1.21,5.22-3-2.1-1.19Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.67,260.77a.2.2,0,0,1-.11,0l-2.63-1.49a.26.26,0,0,1-.12-.21.24.24,0,0,1,.12-.2l5.74-3.26a.24.24,0,0,1,.23,0l2.58,1.46a.22.22,0,0,1,.12.21.22.22,0,0,1-.12.2l-5.69,3.29A.24.24,0,0,1,256.67,260.77ZM254.52,259l2.15,1.22,5.22-3-2.1-1.2Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.59,254.46a.2.2,0,0,1-.11,0l-2.63-1.49a.24.24,0,0,1-.12-.2.26.26,0,0,1,.12-.21l5.74-3.26a.24.24,0,0,1,.23,0l2.58,1.47a.24.24,0,0,1,.12.2.24.24,0,0,1-.12.21l-5.69,3.28A.27.27,0,0,1,267.59,254.46Zm-2.15-1.72,2.15,1.22,5.22-3-2.1-1.19Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.72,244l-.12,0L203,242.44a.24.24,0,0,1-.12-.21.22.22,0,0,1,.12-.2l5.74-3.26a.24.24,0,0,1,.23,0l2.58,1.46a.24.24,0,0,1,.12.2.24.24,0,0,1-.12.21l-5.69,3.28A.19.19,0,0,1,205.72,244Zm-2.15-1.73,2.15,1.22,5.22-3-2.11-1.2Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.64,237.65l-.12,0-2.62-1.49a.22.22,0,0,1-.12-.2.24.24,0,0,1,.12-.21l5.74-3.26a.24.24,0,0,1,.23,0l2.58,1.47a.24.24,0,0,1,0,.4l-5.69,3.29A.27.27,0,0,1,216.64,237.65Zm-2.15-1.72,2.15,1.22,5.22-3-2.11-1.19Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.56,231.35a.27.27,0,0,1-.12,0l-2.62-1.49a.22.22,0,0,1-.12-.21.22.22,0,0,1,.12-.2l5.73-3.26a.26.26,0,0,1,.24,0l2.57,1.46a.22.22,0,0,1,.12.21.23.23,0,0,1-.11.2l-5.7,3.29A.2.2,0,0,1,227.56,231.35Zm-2.15-1.73,2.15,1.22,5.22-3-2.11-1.2Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.22,287.57c9.05,5.23,23.73,5.23,32.78,0s9.06-13.7,0-18.92-23.73-5.23-32.78,0S158.17,282.35,167.22,287.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.15,287.49l-4.59-10.43-5.44,2.88,2.53,10.49a27.78,27.78,0,0,0,7.35-2.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.72,284.77,198.3,275l-1.48.61,4.82,10.95A16,16,0,0,0,203.72,284.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.12,284.33c8.56,4.94,22.43,4.94,31,0s8.55-12.95,0-17.89-22.43-4.94-31,0S159.56,279.39,168.12,284.33Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.56,277.06l-5.44,2.88,1.73,7.17a27.07,27.07,0,0,0,7-2.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.3,275l-1.48.61,3.51,8a15.34,15.34,0,0,0,1.89-1.49Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169.18,281.2c8,4.6,20.89,4.6,28.86,0s8-12.07,0-16.67-20.89-4.6-28.86,0S161.21,276.6,169.18,281.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.1,280.36c7.46,4.14,19.56,4.14,27,0s7.47-10.85,0-15-19.56-4.14-27,0S162.64,276.22,170.1,280.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.46,278.52l16.15-5.65-17.67,4A10.39,10.39,0,0,0,167.46,278.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.14,283.16l-4.53-10.29L185,283.43Q186.57,283.37,188.14,283.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.65,273.63l-19-.76,18.52,2.57A6.41,6.41,0,0,0,202.65,273.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.72,263l-7.11,9.85,10-9A25.33,25.33,0,0,0,190.72,263Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.1,265.37c-.36.2-.69.41-1,.62l14.52,6.88-12.21-8.15C171,264.92,170.52,265.14,170.1,265.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,275.52a10.15,10.15,0,0,0,9.2,0c2.54-1.47,2.54-3.84,0-5.31a10.15,10.15,0,0,0-9.2,0C176.47,271.68,176.47,274.05,179,275.52Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.51,274.65a6.84,6.84,0,0,0,6.2,0c1.71-1,1.71-2.59,0-3.57a6.84,6.84,0,0,0-6.2,0C178.8,272.06,178.8,273.67,180.51,274.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.32,273.61a2.86,2.86,0,0,0,2.58,0,.78.78,0,0,0,0-1.49,2.86,2.86,0,0,0-2.58,0A.79.79,0,0,0,182.32,273.61Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.67,256.14c9.05,5.22,23.73,5.22,32.78,0s9.05-13.7,0-18.93-23.73-5.23-32.78,0S212.61,250.91,221.67,256.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.59,256.05,250,245.63l-5.45,2.87L247.1,259a28.25,28.25,0,0,0,7.35-2.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.17,253.33l-5.42-9.8-1.48.6,4.82,11A16.74,16.74,0,0,0,258.17,253.33Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.56,252.89c8.56,4.94,22.44,4.94,31,0s8.56-12.95,0-17.89-22.43-4.94-31,0S214,248,222.56,252.89Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250,245.63l-5.45,2.87,1.74,7.17a27,27,0,0,0,7-2.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.75,243.53l-1.48.6,3.51,8a16.27,16.27,0,0,0,1.88-1.5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M223.63,249.76c8,4.6,20.89,4.6,28.86,0s8-12.06,0-16.66-20.89-4.6-28.86,0S215.66,245.16,223.63,249.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.55,248.93c7.46,4.14,19.56,4.14,27,0s7.46-10.86,0-15-19.56-4.14-27,0S217.08,244.78,224.55,248.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.9,247.08l16.16-5.65-17.67,4A10.31,10.31,0,0,0,221.9,247.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.58,251.72l-4.52-10.29L239.41,252C240.48,252,241.54,251.86,242.58,251.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.1,242.2l-19-.77L256.57,244A6.37,6.37,0,0,0,257.1,242.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.17,231.59l-7.11,9.84,10-9A26.54,26.54,0,0,0,245.17,231.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.55,233.93c-.36.2-.69.41-1,.62l14.52,6.88-12.21-8.15C225.4,233.48,225,233.7,224.55,233.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.46,244.08a10.15,10.15,0,0,0,9.2,0c2.54-1.46,2.54-3.84,0-5.31a10.21,10.21,0,0,0-9.2,0C230.92,240.24,230.92,242.62,233.46,244.08Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,243.22a6.9,6.9,0,0,0,6.2,0c1.71-1,1.71-2.59,0-3.58a6.84,6.84,0,0,0-6.2,0C233.25,240.63,233.25,242.23,235,243.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.77,242.17a2.8,2.8,0,0,0,2.58,0,.79.79,0,0,0,0-1.49,2.86,2.86,0,0,0-2.58,0A.78.78,0,0,0,236.77,242.17Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.12 227.32 271.6 242.03 272.79 241.34 247.31 226.63 246.12 227.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.56 240.73 266.56 239.54 270.19 237.44 270.19 238.63 266.56 240.73",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.56 240.73 266.56 239.54 270.19 237.44 270.19 238.63 266.56 240.73",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.73 238.5 266.56 239.54 270.19 237.44 268.38 236.39 264.73 238.5",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.74 239.68 266.56 240.73 266.56 239.54 264.73 238.5 264.74 239.68",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.74 239.68 266.56 240.73 266.56 239.54 264.73 238.5 264.74 239.68",
    style: {
      opacity: 0.30000000000000004
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "247.31 226.63 247.31 228.01 246.12 227.32 247.31 226.63"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "189.08 256.05 214.56 270.76 215.75 270.07 190.27 255.36 189.08 256.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.51 269.46 209.51 268.27 213.15 266.17 213.15 267.36 209.51 269.46",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.51 269.46 209.51 268.27 213.15 266.17 213.15 267.36 209.51 269.46",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.69 267.23 209.51 268.27 213.15 266.17 211.33 265.12 207.69 267.23",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.69 268.41 209.51 269.46 209.51 268.27 207.69 267.23 207.69 268.41",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.69 268.41 209.51 269.46 209.51 268.27 207.69 267.23 207.69 268.41",
    style: {
      opacity: 0.30000000000000004
    }
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "190.27 255.36 190.27 256.74 189.08 256.05 190.27 255.36"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "192.72 253.95 218.19 268.66 219.39 267.97 193.91 253.26 192.72 253.95",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.88 263.16 205.88 261.97 209.51 259.87 209.51 261.06 205.88 263.16",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.88 263.16 205.88 261.97 209.51 259.87 209.51 261.06 205.88 263.16",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.05 260.92 205.88 261.97 209.51 259.87 207.69 258.82 204.05 260.92",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.06 262.11 205.88 263.16 205.88 261.97 204.05 260.92 204.06 262.11",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.06 262.11 205.88 263.16 205.88 261.97 204.05 260.92 204.06 262.11",
    style: {
      opacity: 0.30000000000000004
    }
  }), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "193.91 253.26 193.91 254.64 192.72 253.95 193.91 253.26"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "196.36 251.85 221.84 266.56 223.03 265.87 197.55 251.16 196.36 251.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.32 264.41 215.32 263.22 218.96 261.12 218.96 262.31 215.32 264.41",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.32 264.41 215.32 263.22 218.96 261.12 218.96 262.31 215.32 264.41",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.5 262.17 215.32 263.22 218.96 261.12 217.14 260.07 213.5 262.17",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.5 263.36 215.32 264.41 215.32 263.22 213.5 262.17 213.5 263.36",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.5 263.36 215.32 264.41 215.32 263.22 213.5 262.17 213.5 263.36",
    style: {
      opacity: 0.30000000000000004
    }
  }), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "197.55 251.16 197.55 252.54 196.36 251.85 197.55 251.16"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "200 249.75 225.47 264.46 226.67 263.77 201.19 249.06 200 249.75",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.88 254.75 205.88 253.56 209.51 251.46 209.51 252.65 205.88 254.75",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.88 254.75 205.88 253.56 209.51 251.46 209.51 252.65 205.88 254.75",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.05 252.52 205.88 253.56 209.51 251.46 207.69 250.41 204.05 252.52",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.06 253.7 205.88 254.75 205.88 253.56 204.05 252.52 204.06 253.7",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.06 253.7 205.88 254.75 205.88 253.56 204.05 252.52 204.06 253.7",
    style: {
      opacity: 0.30000000000000004
    }
  }), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "201.19 249.06 201.19 250.44 200 249.75 201.19 249.06"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M219.79,277h0l-.18-3.13h-2.83L216.6,277h0a.77.77,0,0,0,.46.7,2.52,2.52,0,0,0,2.27,0A.79.79,0,0,0,219.79,277Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.79,277h0l-.18-3.13h-2.83L216.6,277h0a.77.77,0,0,0,.46.7,2.52,2.52,0,0,0,2.27,0A.79.79,0,0,0,219.79,277Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.2,274.51a.61.61,0,0,1,0-1.16,2.25,2.25,0,0,1,2,0,.61.61,0,0,1,0,1.16A2.18,2.18,0,0,1,217.2,274.51Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.56,274.28h0l-.19-3.13h-2.82l-.19,3.12h0a.75.75,0,0,0,.47.69,2.5,2.5,0,0,0,2.26,0A.76.76,0,0,0,224.56,274.28Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.56,274.28h0l-.19-3.13h-2.82l-.19,3.12h0a.75.75,0,0,0,.47.69,2.5,2.5,0,0,0,2.26,0A.76.76,0,0,0,224.56,274.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,271.76a.61.61,0,0,1,0-1.15,2.2,2.2,0,0,1,2,0,.61.61,0,0,1,0,1.15A2.2,2.2,0,0,1,222,271.76Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.33,271.53h0l-.19-3.12h-2.82l-.19,3.11h0a.75.75,0,0,0,.46.7,2.5,2.5,0,0,0,2.26,0A.76.76,0,0,0,229.33,271.53Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.33,271.53h0l-.19-3.12h-2.82l-.19,3.11h0a.75.75,0,0,0,.46.7,2.5,2.5,0,0,0,2.26,0A.76.76,0,0,0,229.33,271.53Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.74,269a.61.61,0,0,1,0-1.15,2.2,2.2,0,0,1,2,0,.61.61,0,0,1,0,1.15A2.2,2.2,0,0,1,226.74,269Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.11,268.79h0l-.19-3.13H231.1l-.19,3.12h0a.76.76,0,0,0,.46.69,2.5,2.5,0,0,0,2.26,0A.76.76,0,0,0,234.11,268.79Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.11,268.79h0l-.19-3.13H231.1l-.19,3.12h0a.76.76,0,0,0,.46.69,2.5,2.5,0,0,0,2.26,0A.76.76,0,0,0,234.11,268.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 232.51,
    cy: 265.7,
    rx: 1.41,
    ry: 0.82,
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.35,277h0l-.19-3.13h-2.83l-.18,3.12h0a.77.77,0,0,0,.46.7,2.52,2.52,0,0,0,2.27,0A.79.79,0,0,0,229.35,277Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.35,277h0l-.19-3.13h-2.83l-.18,3.12h0a.77.77,0,0,0,.46.7,2.52,2.52,0,0,0,2.27,0A.79.79,0,0,0,229.35,277Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.76,274.53a.61.61,0,0,1,0-1.15,2.18,2.18,0,0,1,2,0c.56.31.56.83,0,1.15A2.18,2.18,0,0,1,226.76,274.53Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.12,274.3h0l-.19-3.13h-2.82l-.19,3.12h0a.75.75,0,0,0,.47.69,2.5,2.5,0,0,0,2.26,0A.75.75,0,0,0,234.12,274.3Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.12,274.3h0l-.19-3.13h-2.82l-.19,3.12h0a.75.75,0,0,0,.47.69,2.5,2.5,0,0,0,2.26,0A.75.75,0,0,0,234.12,274.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.53,271.78a.61.61,0,0,1,0-1.15,2.2,2.2,0,0,1,2,0,.61.61,0,0,1,0,1.15A2.2,2.2,0,0,1,231.53,271.78Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.89,271.56h0l-.19-3.13h-2.82l-.19,3.11h0a.77.77,0,0,0,.46.7,2.5,2.5,0,0,0,2.26,0A.75.75,0,0,0,238.89,271.56Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.89,271.56h0l-.19-3.13h-2.82l-.19,3.11h0a.77.77,0,0,0,.46.7,2.5,2.5,0,0,0,2.26,0A.75.75,0,0,0,238.89,271.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.3,269a.61.61,0,0,1,0-1.15,2.2,2.2,0,0,1,2,0,.61.61,0,0,1,0,1.15A2.2,2.2,0,0,1,236.3,269Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.88,266.05h0l-.19-3.13h-2.82l-.19,3.11h0a.77.77,0,0,0,.46.7,2.5,2.5,0,0,0,2.26,0A.78.78,0,0,0,238.88,266.05Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.88,266.05h0l-.19-3.13h-2.82l-.19,3.11h0a.77.77,0,0,0,.46.7,2.5,2.5,0,0,0,2.26,0A.78.78,0,0,0,238.88,266.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.28,263.53a.61.61,0,0,1,0-1.15,2.2,2.2,0,0,1,2,0,.61.61,0,0,1,0,1.15A2.2,2.2,0,0,1,236.28,263.53Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.88,296h0l.18-3.13h2.83l.18,3.11h0a.77.77,0,0,1-.46.7,2.52,2.52,0,0,1-2.27,0A.79.79,0,0,1,170.88,296Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.88,296h0l.18-3.13h2.83l.18,3.11h0a.77.77,0,0,1-.46.7,2.52,2.52,0,0,1-2.27,0A.79.79,0,0,1,170.88,296Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.47,293.46c.56-.32.56-.83,0-1.15a2.18,2.18,0,0,0-2,0,.61.61,0,0,0,0,1.15A2.18,2.18,0,0,0,173.47,293.46Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.11,293.23h0l.19-3.13h2.83l.18,3.12h0a.78.78,0,0,1-.46.7,2.52,2.52,0,0,1-2.27,0A.77.77,0,0,1,166.11,293.23Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.11,293.23h0l.19-3.13h2.83l.18,3.12h0a.78.78,0,0,1-.46.7,2.52,2.52,0,0,1-2.27,0A.77.77,0,0,1,166.11,293.23Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.7,290.72a.61.61,0,0,0,0-1.16,2.18,2.18,0,0,0-2,0,.61.61,0,0,0,0,1.16A2.25,2.25,0,0,0,168.7,290.72Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.34,290.49h0l.19-3.13h2.82l.19,3.11h0a.76.76,0,0,1-.47.7,2.5,2.5,0,0,1-2.26,0A.75.75,0,0,1,161.34,290.49Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.34,290.49h0l.19-3.13h2.82l.19,3.11h0a.76.76,0,0,1-.47.7,2.5,2.5,0,0,1-2.26,0A.75.75,0,0,1,161.34,290.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.93,288a.61.61,0,0,0,0-1.15,2.2,2.2,0,0,0-2,0,.61.61,0,0,0,0,1.15A2.2,2.2,0,0,0,163.93,288Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.57,287.74h0l.19-3.13h2.82l.19,3.12h0a.77.77,0,0,1-.46.7,2.5,2.5,0,0,1-2.26,0A.76.76,0,0,1,156.57,287.74Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.57,287.74h0l.19-3.13h2.82l.19,3.12h0a.77.77,0,0,1-.46.7,2.5,2.5,0,0,1-2.26,0A.76.76,0,0,1,156.57,287.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.16,285.23a.61.61,0,0,0,0-1.16,2.27,2.27,0,0,0-2,0,.61.61,0,0,0,0,1.16A2.2,2.2,0,0,0,159.16,285.23Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.79,285h0l.19-3.13h2.82L155,285h0a.76.76,0,0,1-.46.69,2.5,2.5,0,0,1-2.26,0A.77.77,0,0,1,151.79,285Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.79,285h0l.19-3.13h2.82L155,285h0a.76.76,0,0,1-.46.69,2.5,2.5,0,0,1-2.26,0A.77.77,0,0,1,151.79,285Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.39,282.48a.61.61,0,0,0,0-1.15,2.2,2.2,0,0,0-2,0,.61.61,0,0,0,0,1.15A2.2,2.2,0,0,0,154.39,282.48Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.08,300.91a.78.78,0,0,0,0-1.48,2.88,2.88,0,0,0-2.56,0,.78.78,0,0,0,0,1.48A2.88,2.88,0,0,0,183.08,300.91Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.68,279.9a.78.78,0,0,0,0-1.47,2.8,2.8,0,0,0-2.55,0c-.71.41-.71,1.07,0,1.47A2.8,2.8,0,0,0,146.68,279.9Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.64,246.28a.78.78,0,0,0,0-1.48,2.86,2.86,0,0,0-2.55,0,.78.78,0,0,0,0,1.48A2.86,2.86,0,0,0,277.64,246.28Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.24,225.27c.71-.41.71-1.07,0-1.47a2.8,2.8,0,0,0-2.55,0,.78.78,0,0,0,0,1.47A2.8,2.8,0,0,0,241.24,225.27Z",
    style: {
      fill: "#6B9ADF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hand--inject-145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.91,187s20.61,13.85,25.05,17.08a23.52,23.52,0,0,1,5.69,6.52c.9,1.45,1.61,2.94,2.49,4.4s1.69,2.45,2.92,4.31a5.09,5.09,0,0,1,.8,3.67,31,31,0,0,1-.5,3.41c-.22,1.18-.5,2.37-.78,3.53-.1.43-.16.88-.25,1.32-.16.79-.51,1.49-.69,2.27a3.63,3.63,0,0,0,0,1.88c.17.56.84,1.58.46,2.18s-1.66.47-2.2.38a7.11,7.11,0,0,1-4.15-3.05,30.78,30.78,0,0,1-2.43-5c-.58-1.31-.94-2.72-1.51-4-.25-.57-1.13-2.71-2-2.57-.61.1-.68,1.57-.74,2-.21,1.78-.37,6.24-3,6.28-1.24,0-1.25-1-1.25-2,0-2.68-.26-5.27-.45-7.95-.22-3.16.92-5.05,0-6.86a8.09,8.09,0,0,0-3.68-3.2c-5.1-2.68-14.62-5.9-22-9.21",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.66,233.46c-.41-.57-.89-1.26-1.41-2.09-1.55-2.5-3.14-8.13-3.14-8.13s.59,2.83,1.32,5.42a29.71,29.71,0,0,0,3.34,7h0a1.53,1.53,0,0,1-.11-.29,3.63,3.63,0,0,1,0-1.88A.14.14,0,0,1,245.66,233.46Z",
    style: {
      fill: "#f28f8f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--laptop--inject-145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349,214.15l-30.5-17.6a1.72,1.72,0,0,0-1.75,0l-52.9,30.54a.39.39,0,0,0,0,.68l30.78,17.77Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.72,210.44v.69a2.82,2.82,0,0,1-1.41,2.44L296,242a2.79,2.79,0,0,1-1.4.37,2.9,2.9,0,0,1-1.42-.37l-26.86-15.46a2.84,2.84,0,0,1-1.4-2.44v-1h0a.37.37,0,0,0,.18.31l29.5,17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.72,210.44l-29.21-16.87a1.68,1.68,0,0,0-1.68,0l-50.69,29.27a.38.38,0,0,0,0,.65l29.49,17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.36 238.04 278.6 228.95 324.68 202.34 340.52 211.39 294.36 238.04",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.52 211.38 339.92 211.73 324.68 203.04 279.2 229.3 278.6 228.95 324.68 202.34 340.52 211.38",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.61 212.75 286.9 212.92 294.63 217.38 308.37 209.45 308.65 209.29 300.64 204.66 286.61 212.75",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.9 212.92 294.63 217.38 308.37 209.45 300.64 204.99 286.9 212.92",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.63,240.52v1.87A2.79,2.79,0,0,0,296,242l49.28-28.45a2.82,2.82,0,0,0,1.41-2.44v-.69Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.42,240.93a3.32,3.32,0,0,0,2.88-.22l49.06-28.32a3.34,3.34,0,0,0,1.62-2.34l5.38-32a4.91,4.91,0,0,0,0-.55,3.35,3.35,0,0,0-1-2.37l-51,29.44a2.45,2.45,0,0,0-1.2,1.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.63,240.52l.33.19a2.77,2.77,0,0,0,.46.22l5.81-34.66a2.45,2.45,0,0,1,1.2-1.73l51-29.44a3.22,3.22,0,0,0-.68-.52l-51.09,29.5a2.51,2.51,0,0,0-1.2,1.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.7,205.2l-.79-.46a2.53,2.53,0,0,0-.47,1.07l-5.81,34.71.33.19a2.77,2.77,0,0,0,.46.22l5.81-34.66A2.41,2.41,0,0,1,301.7,205.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.06,211.37c.35-2.15,2.57-5,4.94-6.37s4-.74,3.64,1.41-2.57,5-4.94,6.36S322.7,213.51,323.06,211.37Z",
    style: {
      fill: "#6B9ADF"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speaker-1--inject-145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speaker--inject-145"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.12,334.36,79.56,361.82a10.33,10.33,0,0,0-4.66,8.08v55.86a10.33,10.33,0,0,0,4.66,8.08L114,453.72a10.36,10.36,0,0,0,9.33,0l47.56-27.46a10.32,10.32,0,0,0,4.67-8.08V362.32a10.32,10.32,0,0,0-4.67-8.08l-34.43-19.88A10.36,10.36,0,0,0,127.12,334.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.32,387.09l47.56-27.46c2.58-1.49,4.67-.28,4.67,2.69v55.86a10.32,10.32,0,0,1-4.67,8.08l-47.56,27.46c-2.57,1.48-4.66.28-4.66-2.7V395.17A10.3,10.3,0,0,1,123.32,387.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,387.09,79.56,367.21c-2.57-1.49-4.66-.28-4.66,2.69v55.86a10.33,10.33,0,0,0,4.66,8.08L114,453.72c2.58,1.48,4.67.28,4.67-2.7V395.17A10.29,10.29,0,0,0,114,387.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.45,334.36l34.43,19.88c2.58,1.49,2.58,3.9,0,5.39l-47.56,27.46a10.36,10.36,0,0,1-9.33,0L79.56,367.21c-2.57-1.49-2.57-3.9,0-5.39l47.56-27.46A10.36,10.36,0,0,1,136.45,334.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.1,429.76c10.82-6.24,19.59-21.43,19.59-33.93s-8.77-17.55-19.59-11.31S127.51,406,127.51,418.45,136.28,436,147.1,429.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.1,427.5c9.74-5.62,17.63-19.29,17.63-30.53s-7.89-15.8-17.63-10.18-17.62,19.29-17.62,30.53S137.37,433.12,147.1,427.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.1,419c5.68-3.28,10.29-11.26,10.29-17.83s-4.61-9.22-10.29-5.94-10.29,11.26-10.29,17.83S141.42,422.31,147.1,419Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.1,410.67a6.74,6.74,0,0,0,3.06-5.29c0-1.95-1.37-2.74-3.06-1.76a6.73,6.73,0,0,0-3,5.29C144.05,410.86,145.41,411.65,147.1,410.67Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.1,410.67a6.74,6.74,0,0,0,3.06-5.29c0-1.95-1.37-2.74-3.06-1.76a6.73,6.73,0,0,0-3,5.29C144.05,410.86,145.41,411.65,147.1,410.67Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.45,364.93a3.71,3.71,0,0,0-1.67,2.89c0,1.07.75,1.5,1.67,1a3.68,3.68,0,0,0,1.67-2.88C172.12,364.83,171.37,364.4,170.45,364.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.7,391.36a3.68,3.68,0,0,0-1.67,2.89c0,1.06.75,1.49,1.67,1a3.68,3.68,0,0,0,1.67-2.89C126.37,391.26,125.62,390.83,124.7,391.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.45,417.59a3.68,3.68,0,0,0-1.67,2.89c0,1.06.75,1.49,1.67,1a3.7,3.7,0,0,0,1.67-2.89C172.12,417.49,171.37,417.06,170.45,417.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.7,444A3.71,3.71,0,0,0,123,446.9c0,1.07.75,1.5,1.67,1a3.68,3.68,0,0,0,1.67-2.88C126.37,443.91,125.62,443.48,124.7,444Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.46,406.2v-9.44c0-3,2.09-4.18,4.67-2.69l21.3,12.3a10.29,10.29,0,0,1,4.66,8.08v9.44c0,3-2.08,4.18-4.66,2.69l-21.3-12.3A10.29,10.29,0,0,1,81.46,406.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.08,423.85c1.55.9,2.8.17,2.8-1.61v-8.7a6.2,6.2,0,0,0-2.8-4.85l-3.76-2.17v15.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.47,396.8c-1.54-.89-2.79-.17-2.79,1.61v8.7A6.22,6.22,0,0,0,86.47,412l3.77,2.17V399Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--musical-notes--inject-145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--musical-notes--inject-145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-145",
    d: "M298.21,85.44l-.86,12.31a3.19,3.19,0,0,0-1.07-.28,3.23,3.23,0,1,0,3,3.45l.79-11,11.3-2.14h0l-.76,10.93a3.37,3.37,0,0,0-1.06-.27,3.23,3.23,0,1,0,3,3.45h0l1.26-18.26Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-145",
    d: "M276.92,133.23a5.76,5.76,0,0,1,2.14-1.08,12.2,12.2,0,0,1,3.19-.35,22.78,22.78,0,0,0,4.29-.24,5.31,5.31,0,0,0,3.55-2.22,5.4,5.4,0,0,1-2.49.23c-2-.26-3.91-1.84-5.81-2.51-2.83-1-5.25-.32-8.08,1.13.59,2.56,1.12,5.14,1.68,7.71l1.32,6.06c0,.19.52,2.76.52,2.76a5.44,5.44,0,0,0-2.37,0,4.43,4.43,0,1,0,5.28,3.38Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--musical-note--inject-145",
    d: "M234.16,94.89a6.25,6.25,0,0,1,1-2.4,13.39,13.39,0,0,1,2.38-2.55,24.54,24.54,0,0,0,3.37-3.23,5.84,5.84,0,0,0,1.35-4.34,6.07,6.07,0,0,1-1.89,1.95c-1.83,1.19-4.52,1.25-6.56,2-3,1.18-4.54,3.45-5.85,6.65,2.3,1.69,4.56,3.44,6.84,5.16l5.37,4,2.38,1.9a5.9,5.9,0,0,0-2,1.65,4.81,4.81,0,1,0,6.73-1Z",
    style: {
      fill: "#6B9ADF"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusiccc);
export default __webpack_public_path__ + "static/media/musiccc.80526adb55476b6f58308013c2e76bfb.svg";
export { ForwardRef as ReactComponent };